<template>
  <el-container style="height: 100vh">
    <el-aside style="width: 185px;">
      <sidebar />
    </el-aside>
    <el-container>
      <el-header> <navbar /></el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <modal-idle v-if="isIdle" />
  </el-container>
</template>

<script>
  import Sidebar from '../components/sidebar/Sidebar.vue'
  import Navbar from '../views/layout/components/Navbar.vue'
  import ModalIdle from '@/components/ModalIdle'

  export default {
    name: 'AppLayout',
    components: { Sidebar, Navbar, ModalIdle },
    data() {
      return {}
    },
    mounted() {
      this.$store.dispatch('GetUserInfo')
    },
    computed: {
      isIdle() {
        return this.$store.state.idleVue.isIdle
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-main {
    width: 100%;
    height: 100%;
  }
</style>
